import React from 'react';
import {
  FDDialog, FDDialogActions, FDDialogContent, FDDialogTitle, FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';

const TaxStrategySummaryNoteDialog = ({ open, setOpen, onClose }) => {
  return (
    <FDDialog
      open={open}
      onClose={() => {
        onClose();
        setOpen(false);
      }}
      closeOnBackdropClick
      dialogWidth={'md'}
    >
      <FDDialogTitle value={'Notes'} />
      <FDDialogContent>
        <FDStack direction={'column'} spacing={1} width={'100%'}>
          <MetaControlField attr={'content'} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Save and Close'}
          onClick={() => {
            onClose();
            setOpen(false);
          }}
        />
      </FDDialogActions>
    </FDDialog>
  );
};

TaxStrategySummaryNoteDialog.defaultProps = {

};

TaxStrategySummaryNoteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TaxStrategySummaryNoteDialog;
